// extracted by mini-css-extract-plugin
export default {"IssueSidePanelContent":"IssueSidePanel-module__IssueSidePanelContent--EB1br"};